/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Exclusive_MessageInputs */

const en_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI is available exclusively in the Brave browser.`)
};

const id_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI tersedia secara eksklusif di browser Brave.`)
};

const ms_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI tersedia secara eksklusif di penyemak imbas Brave.`)
};

const ca_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La IA Leo només està disponible al navegador de Brave.`)
};

const cs_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI je k dispozici výhradně v prohlížeči Brave.`)
};

const da_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI er udelukkende tilgængelig i Brave-browseren.`)
};

const de_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI ist ausschließlich im Brave Browser verfügbar.`)
};

const et_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI on saadaval ainult Brave'i brauseris.`)
};

const es_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI está disponible exclusivamente en el navegador de Brave.`)
};

const fr_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI est disponible exclusivement dans le navigateur Brave.`)
};

const hr_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI ekskluzivno je dostupan u pregledniku Brave.`)
};

const it_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI è disponibile esclusivamente nel browser Brave.`)
};

const lv_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo MI ir pieejams tikai Brave pārlūkā.`)
};

const lt_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Leo“ dirbtinis intelektas prieinamas tik „Brave“ naršyklėje.`)
};

const hu_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A Leo AI kizárólag a Brave böngészőben érhető el.`)
};

const nl_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI is exclusief beschikbaar in de Brave-browser.`)
};

const nb_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI er kun tilgjengelig i Braves nettleser.`)
};

const pl_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcja Leo AI jest dostępna wyłącznie w przeglądarce Brave.`)
};

const pt_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O assistente Leo AI está disponível exclusivamente no navegador Brave.`)
};

const ro_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI este disponibil exclusiv în browserul Brave.`)
};

const sk_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI je k dispozícii výlučne v prehliadači Brave.`)
};

const sl_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI je na voljo izključno v brskalniku Brave.`)
};

const fi_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI on saatavilla ainoastaan Brave-selaimessa.`)
};

const sv_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI är endast tillgänglig i Brave-webbläsaren.`)
};

const vi_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI chỉ có trên trình duyệt Brave.`)
};

const tr_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo YZ yalnızca Brave tarayıcısında kullanılabilir.`)
};

const el_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το Leo AI είναι διαθέσιμο αποκλειστικά στο πρόγραμμα περιήγησης Brave.`)
};

const bg_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI се предлага изключително в браузъра Brave.`)
};

const ru_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI доступен только в браузере Brave.`)
};

const sr_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI је доступан искључиво у Brave прегледачу.`)
};

const uk_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI доступний виключно в браузері Brave.`)
};

const ka_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo-ს ხელოვნური ინტელექტი ექსკლუზიურად Brave ბრაუზერშია ხელმისაწვდომი.`)
};

const hi_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लियो एआई केवल ब्रेव ब्राउज़र में उपलब्ध है।`)
};

const th_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI มีให้บริการเฉพาะในเบราว์เซอร์ Brave เท่านั้น`)
};

const ko_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레오 AI는 Brave 브라우저에서만 사용할 수 있습니다.`)
};

const zh_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo 人工智能仅在 Brave 浏览器中提供。`)
};

const zh_tw_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI 僅限於 Brave 瀏覽器中使用。`)
};

const ja_leo_exclusive_message = /** @type {(inputs: Leo_Exclusive_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI はBraveブラウザでのみ利用できます。`)
};

/**
* | output |
* | --- |
* | "Leo AI is available exclusively in the Brave browser." |
*
* @param {Leo_Exclusive_MessageInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_exclusive_message = /** @type {((inputs?: Leo_Exclusive_MessageInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Exclusive_MessageInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_exclusive_message(inputs)
	if (locale === "ms") return ms_leo_exclusive_message(inputs)
	if (locale === "ca") return ca_leo_exclusive_message(inputs)
	if (locale === "cs") return cs_leo_exclusive_message(inputs)
	if (locale === "da") return da_leo_exclusive_message(inputs)
	if (locale === "de") return de_leo_exclusive_message(inputs)
	if (locale === "et") return et_leo_exclusive_message(inputs)
	if (locale === "es") return es_leo_exclusive_message(inputs)
	if (locale === "fr") return fr_leo_exclusive_message(inputs)
	if (locale === "hr") return hr_leo_exclusive_message(inputs)
	if (locale === "it") return it_leo_exclusive_message(inputs)
	if (locale === "lv") return lv_leo_exclusive_message(inputs)
	if (locale === "lt") return lt_leo_exclusive_message(inputs)
	if (locale === "hu") return hu_leo_exclusive_message(inputs)
	if (locale === "nl") return nl_leo_exclusive_message(inputs)
	if (locale === "nb") return nb_leo_exclusive_message(inputs)
	if (locale === "pl") return pl_leo_exclusive_message(inputs)
	if (locale === "pt") return pt_leo_exclusive_message(inputs)
	if (locale === "ro") return ro_leo_exclusive_message(inputs)
	if (locale === "sk") return sk_leo_exclusive_message(inputs)
	if (locale === "sl") return sl_leo_exclusive_message(inputs)
	if (locale === "fi") return fi_leo_exclusive_message(inputs)
	if (locale === "sv") return sv_leo_exclusive_message(inputs)
	if (locale === "vi") return vi_leo_exclusive_message(inputs)
	if (locale === "tr") return tr_leo_exclusive_message(inputs)
	if (locale === "el") return el_leo_exclusive_message(inputs)
	if (locale === "bg") return bg_leo_exclusive_message(inputs)
	if (locale === "ru") return ru_leo_exclusive_message(inputs)
	if (locale === "sr") return sr_leo_exclusive_message(inputs)
	if (locale === "uk") return uk_leo_exclusive_message(inputs)
	if (locale === "ka") return ka_leo_exclusive_message(inputs)
	if (locale === "hi") return hi_leo_exclusive_message(inputs)
	if (locale === "th") return th_leo_exclusive_message(inputs)
	if (locale === "ko") return ko_leo_exclusive_message(inputs)
	if (locale === "zh") return zh_leo_exclusive_message(inputs)
	if (locale === "zh-tw") return zh_tw_leo_exclusive_message(inputs)
	if (locale === "ja") return ja_leo_exclusive_message(inputs)
	return en_leo_exclusive_message(inputs)
});